export default "https://a.travel-assets.com/partner-portal/tools-lg-connectivity-illustration.68360d060a30.svg";